import EditContactInformationModal from './EditContactInformationModal';

export default EditContactInformationModal;
